const urlCatalogo = 'https://catalogo.kierosrl.com.ar/'
const urlBackend = 'https://kierosrl.backend.pre-produccion.com/'
export { urlCatalogo, urlBackend }